import React, { useEffect, useState } from "react";
import { DatePicker, Input, Select } from "uxp/components";
import './ExtendedDatePicker.scss';

interface IExtendedDatePickerProps {
    datetime: string | Date | null,
    onChange: (datetime: string | Date) => void,
}

interface IRelativeDate {
    before: boolean,
    count: number,
    bucket: string
}

const regExp = /^([+-]?)(\d+)\s*(m|h|d|w|mo|y)$/i;

export function isRelativeDate(ds: string): boolean {
    return regExp.test(ds)
}

export function parseRelativeDate(ds: string): IRelativeDate {

    const match = ds.match(regExp);

    if (match) {
        const [_, sign, number, bucket] = match;
        return {
            before: sign == '-',
            count: parseInt(number, 10),
            bucket
        };
    }
    return {
        before: true,
        count: 0,
        bucket: 'd'
    };
}

export function serialiseRelativeDate(rd: IRelativeDate): string {
    const ds = `${rd.before ? '-' : '+'}${rd.count}${rd.bucket}`
    return ds
}

export const ExtendedDatePicker: React.FC<IExtendedDatePickerProps> = (props) => {
    const { datetime, onChange } = props
    const [rD, setRD] = useState<IRelativeDate>({ before: true, count: 0, bucket: 'd' })
    const [isRD, setIsRD] = useState(true)

    useEffect(() => {
        if (typeof datetime == 'string' && isRelativeDate(datetime)) {
            const _rd = parseRelativeDate(datetime)
            setRD(_rd)
            setIsRD(true)
        }
        else {
            setIsRD(false)
        }
    }, [datetime])

    function updateRD(field: string, val: any) {
        const _rd: any = { ...rD }
        _rd[field] = val

        onChange(serialiseRelativeDate(_rd))
        setRD(_rd)
    }

    return <div className="lucy-query-engin-date-time-picker-component-container">
        <div className="lucy-query-engine-date-time-container">
            <div className="lucy-query-engine-date-time-container-type-picker">
                <Select
                    selected={isRD ? 'relative' : 'specific'}
                    onChange={s => setIsRD(s == 'relative')}
                    options={[
                        { label: 'Relative date', value: 'relative' },
                        { label: 'Specific date', value: 'specific' },
                    ]}
                    // className="lucy-query-engine-dp-input"
                    dropdownClassname="lucy-query-engin-dp-dropdown"
                />
            </div>

            {isRD ? <>
                <Input
                    type="number"
                    value={(rD.count || 0).toString()}
                    onChange={s => updateRD('count', Number(s))}
                    className="lucy-query-engine-dp-input"
                />
                <Select
                    selected={rD.bucket || 'd'}
                    onChange={s => updateRD('bucket', s)}
                    options={[
                        { label: 'Minute(s)', value: 'm' },
                        { label: 'Hour(s)', value: 'h' },
                        { label: 'Day(s)', value: 'd' },
                        { label: 'Week(s)', value: 'w' },
                        { label: 'Month(s)', value: 'mo' },
                        { label: 'Year(s)', value: 'y' },
                    ]}
                    className="lucy-query-engine-dp-input"
                    dropdownClassname="lucy-query-engin-dp-dropdown"
                />
                {/* <Select
                    selected={rD.before ? 'before' : 'after'}
                    onChange={val => updateRD('before', val == 'before')}
                    options={[
                        { label: 'Before', value: 'before' },
                        { label: 'After', value: 'after' },
                    ]}
                    className="lucy-query-engine-dp-input"
                    dropdownClassname="lucy-query-engin-dp-dropdown"
                /> */}
                <div className="lucy-query-engine-date-time-label">before current date </div>
            </>
                : <DatePicker
                    title="date"
                    date={(typeof datetime != 'string' || (typeof datetime == 'string' && !isRelativeDate(datetime))) ? datetime : ''}
                    onChange={date => onChange(date)}
                />
            }
        </div>
    </div>
}